import { render, staticRenderFns } from "./PayAuthorityInfo.vue?vue&type=template&id=508d61f3&scoped=true"
import script from "./PayAuthorityInfo.vue?vue&type=script&lang=ts"
export * from "./PayAuthorityInfo.vue?vue&type=script&lang=ts"
import style0 from "./PayAuthorityInfo.vue?vue&type=style&index=0&id=508d61f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d61f3",
  null
  
)

export default component.exports